/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as S from './terms.styles';
import imgUrbanDark from '../../../../assets/PNG/urbanCompass_dark.png';
import imgUrbanLight from '../../../../assets/PNG/urbanCompass_light.png';
import traditionalFlag from '../../../../assets/PNG/traditionalFlag.png';
import { getCurrentYear } from '../../../../helper/validationHelper';

const TermsPage = ({ isDark, toggleTheme }) => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  const handleSignIn = () => {
    navigate('/login');
  };

  return (
    <S.PageWrapper>
      {/* Navbar */}
      <S.Navbar>
        <S.NavContent>
          <div>
            <Link to="/">
              {isDark ? (
                <S.Logo src={imgUrbanDark} alt="logo" />
              ) : (
                <S.Logo src={imgUrbanLight} alt="logo" />
              )}
            </Link>
          </div>
          <S.NavContent>
            <S.ThemeToggleButton onClick={toggleTheme}>
              <S.LightModeIcon
                $isDark={isDark}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
              >
                <path d="M480-360q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Zm0 80q-83 0-141.5-58.5T280-480q0-83 58.5-141.5T480-680q83 0 141.5 58.5T680-480q0 83-58.5 141.5T480-280ZM200-440H40v-80h160v80Zm720 0H760v-80h160v80ZM440-760v-160h80v160h-80Zm0 720v-160h80v160h-80ZM256-650l-101-97 57-59 96 100-52 56Zm492 496-97-101 53-55 101 97-57 59Zm-98-550 97-101 59 57-100 96-56-52ZM154-212l101-97 55 53-97 101-59-57Zm326-268Z" />
              </S.LightModeIcon>
              <S.DarkModeIcon
                $isDark={isDark}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
              >
                <path d="M480-120q-150 0-255-105T120-480q0-150 105-255t255-105q14 0 27.5 1t26.5 3q-41 29-65.5 75.5T444-660q0 90 63 153t153 63q55 0 101-24.5t75-65.5q2 13 3 26.5t1 27.5q0 150-105 255T480-120Zm0-80q88 0 158-48.5T740-375q-20 5-40 8t-40 3q-123 0-209.5-86.5T364-660q0-20 3-40t8-40q-78 32-126.5 102T200-480q0 116 82 198t198 82Zm-10-270Z" />
              </S.DarkModeIcon>
            </S.ThemeToggleButton>{' '}
            <div>
              <S.SignInButton onClick={handleSignIn}>Sign In</S.SignInButton>
            </div>
          </S.NavContent>
        </S.NavContent>
      </S.Navbar>

      {/* Header */}
      <S.HeaderSection>
        <S.HeaderContent>
          <S.HeaderTitle>Terms and Conditions</S.HeaderTitle>
        </S.HeaderContent>
      </S.HeaderSection>

      {/* Content */}
      <S.ContentSection>
        <div>
          <S.ContentBlock>
            <S.LastUpdated>
              <strong>Last updated</strong>: 01st January 2026
            </S.LastUpdated>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionParagraph>
              These Terms and Conditions ("Terms") govern access to and use of the
              software-as-a-service platform, applications, APIs, and related services
              (collectively, the "Service") provided by <strong>Urban Compass Software Pty</strong>{' '}
              Ltd an Australian company incorporated under the laws of the Commonwealth of
              Australia, with its principal place of business at{' '}
              <strong>315/566 St Kilda Road Melbourne 3000 Australia</strong>
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionParagraph>
              By accessing or using the Service, you ("Customer," "you," or "your") agree to be
              bound by these Terms. If you do not agree, do not use the Service.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>1. Definitions</S.SectionTitle>
            <S.List>
              <li>
                <strong>"Account"</strong> means an account registered by a customer to access the
                Service.
              </li>
              <li>
                <strong>"Authorized Users"</strong> means individuals authorized by Customer to use
                the Service under Customer's Account.
              </li>
              <li>
                <strong>"Customer Data"</strong> means data, content, or information submitted to
                the Service by or on behalf of Customer.
              </li>
              <li>
                <strong>"Documentation"</strong> means user guides, technical documentation, and
                policies made available by Company.
              </li>
              <li>
                <strong>"Subscription"</strong> means the right to access and use the Service during
                the applicable subscription term.
              </li>
            </S.List>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>2. Eligibility and Account Registration</S.SectionTitle>
            <S.SectionParagraph>
              You represent that you are at least 18 years old and have the legal authority to enter
              into these Terms. You agree to provide accurate and complete information when creating
              an Account and to keep such information up to date. You are responsible for
              maintaining the confidentiality of your Account credentials and for all activities
              that occur under your Account.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>3. Subscription and License</S.SectionTitle>
            <S.SectionParagraph>
              Subject to these Terms and payment of applicable fees, Company grants you a limited,
              non-exclusive, non-transferable, non-sublicensable license to access and use the
              Service for your internal business purposes during the Subscription term.
            </S.SectionParagraph>
            <S.SectionParagraph>Except as expressly permitted, you may not:</S.SectionParagraph>
            <S.List>
              <li>Copy, modify, or create derivative works of the Service;</li>
              <li>Reverse engineer, decompile, or attempt to extract source code;</li>
              <li>Rent, sell, resell, or provide the Service to third parties;</li>
              <li>Use the Service in violation of applicable laws or regulations.</li>
            </S.List>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>4. Fees and Payment</S.SectionTitle>
            <S.SectionParagraph>
              Fees, billing cycles, and payment terms are described on the applicable order form,
              pricing page, or invoice. All fees are non-refundable unless expressly stated
              otherwise. Company may suspend or terminate access to the Service for overdue
              payments.
            </S.SectionParagraph>
            <S.SectionParagraph>
              You are responsible for all applicable taxes, excluding taxes based on Company's
              income.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>5. Customer Data and Data Protection (Australia)</S.SectionTitle>
            <S.SubsectionTitle>5.1 Ownership</S.SubsectionTitle>
            <S.SectionParagraph>
              Customer retains all rights, title, and interest in and to Customer Data. You grant
              Company a limited license to host, process, and display Customer Data solely to
              provide the Service.
            </S.SectionParagraph>
            <S.SubsectionTitle>5.2 Data Security</S.SubsectionTitle>
            <S.SectionParagraph>
              Company will implement reasonable administrative, technical, and organizational
              measures designed to protect Customer Data, in accordance with industry standards and
              applicable Australian privacy laws.
            </S.SectionParagraph>
            <S.SubsectionTitle>5.3 Privacy and APPs</S.SubsectionTitle>
            <S.SectionParagraph>
              Company will handle personal information in accordance with the Privacy Act 1988 (Cth)
              and the Australian Privacy Principles (APPs). Our collection, use, and disclosure of
              personal information are described in our Privacy Policy, which is incorporated by
              reference.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>6. Acceptable Use</S.SectionTitle>
            <S.SectionParagraph>You agree not to use the Service to:</S.SectionParagraph>
            <S.List>
              <li>Upload or transmit unlawful, harmful, or infringing content;</li>
              <li>Interfere with or disrupt the integrity or performance of the Service;</li>
              <li>Attempt unauthorized access to systems or networks;</li>
              <li>Send spam or malicious code.</li>
            </S.List>
            <S.SectionParagraph>
              Company may suspend or terminate access for violations of this section.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>7. Service Availability and Support</S.SectionTitle>
            <S.SectionParagraph>
              Company aims to provide commercially reasonable uptime but does not guarantee
              uninterrupted or error-free operation. Maintenance, updates, or outages may occur.
              Support, if offered, will be provided in accordance with Company's support policies.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>8. Intellectual Property</S.SectionTitle>
            <S.SectionParagraph>
              The Service, Documentation, and all related intellectual property rights are owned by
              Company or its licensors. No rights are granted except as expressly stated in these
              Terms.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>9. Confidentiality</S.SectionTitle>
            <S.SectionParagraph>
              Each party agrees to protect the other party's confidential information using
              reasonable care and to use such information solely to perform under these Terms.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>10. Term and Termination</S.SectionTitle>
            <S.SubsectionTitle>10.1 Term</S.SubsectionTitle>
            <S.SectionParagraph>
              These Terms remain in effect for the duration of your Subscription unless earlier
              terminated.
            </S.SectionParagraph>
            <S.SubsectionTitle>10.2 Termination</S.SubsectionTitle>
            <S.SectionParagraph>
              Either party may terminate for material breach if such breach is not cured within
              thirty (30) days of written notice. Company may suspend or terminate immediately for
              misuse of the Service or non-payment.
            </S.SectionParagraph>
            <S.SubsectionTitle>10.3 Effect of Termination</S.SubsectionTitle>
            <S.SectionParagraph>
              Upon termination, your access to the Service will cease. Customer Data may be deleted
              in accordance with Company's data retention policies.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>11. Australian Consumer Law Disclaimers</S.SectionTitle>
            <S.SectionParagraph>
              Nothing in these Terms excludes, restricts, or modifies any consumer guarantees,
              rights, or remedies conferred by the Australian Consumer Law (ACL) or any other
              applicable law that cannot be excluded by law.
            </S.SectionParagraph>
            <S.SectionParagraph>
              To the maximum extent permitted by law, the Service is provided "as is" and "as
              available," and Company disclaims all other warranties, express or implied, including
              warranties of merchantability, fitness for a particular purpose, and non-infringement.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>12. Limitation of Liability (Australia)</S.SectionTitle>
            <S.SectionParagraph>
              To the maximum extent permitted by law, and subject to your rights under the
              Australian Consumer Law:
            </S.SectionParagraph>
            <S.SectionParagraph>
              (a) Company will not be liable for any indirect, incidental, special, consequential,
              or punitive damages, including loss of profits, revenue, data, or business
              interruption; and
              <br />
              (b) Company's total aggregate liability arising out of or in connection with these
              Terms will not exceed the total fees paid by Customer to Company in the twelve (12)
              months preceding the event giving rise to the claim.
            </S.SectionParagraph>
            <S.SectionParagraph>
              Where liability cannot be excluded under the ACL, Company's liability is limited (at
              Company's option) to re-supplying the services or paying the cost of having the
              services re-supplied.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>13. Indemnification</S.SectionTitle>
            <S.SectionParagraph>
              You agree to indemnify and hold harmless Company from claims arising out of your use
              of the Service, violation of these Terms, or infringement of third-party rights.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>14. Governing Law and Jurisdiction (Australia)</S.SectionTitle>
            <S.SectionParagraph>
              These Terms are governed by the laws of the Commonwealth of Australia and the State or
              Territory in which Company is registered, without regard to conflict of law
              principles.
            </S.SectionParagraph>
            <S.SectionParagraph>
              The parties submit to the exclusive jurisdiction of the courts of that State or
              Territory.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>15. Changes to Terms</S.SectionTitle>
            <S.SectionParagraph>
              Company may update these Terms from time to time. Material changes will be
              communicated through the Service or by other reasonable means. Continued use of the
              Service after changes become effective constitutes acceptance.
            </S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>16. Miscellaneous</S.SectionTitle>
            <S.List>
              <li>
                <strong>Assignment:</strong> You may not assign these Terms without Company's prior
                written consent.
              </li>
              <li>
                <strong>Force Majeure:</strong> Neither party is liable for delays caused by events
                beyond reasonable control.
              </li>
              <li>
                <strong>Severability:</strong> If any provision is held unenforceable, the remaining
                provisions remain in effect.
              </li>
              <li>
                <strong>Entire Agreement:</strong> These Terms constitute the entire agreement
                between the parties regarding the Service.
              </li>
            </S.List>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.SectionTitle>17. Contact Information</S.SectionTitle>
            <S.SectionParagraph>For questions about these Terms, contact:</S.SectionParagraph>
          </S.ContentBlock>

          <S.ContentBlock>
            <S.ContactInfo>
              <div>
                <strong>Urban Compass Software Pty Ltd</strong>
              </div>
              <div>
                <strong>Email:</strong> info@urbancompasssoftware.com
              </div>
              <div>
                <strong>Address:</strong> 315/566 St Kilda Road Melbourne 3000 Australia
              </div>
            </S.ContactInfo>
          </S.ContentBlock>
        </div>
      </S.ContentSection>

      {/* Acknowledgement */}
      <S.AcknowledgementSection>
        <S.AcknowledgementText>
          In the spirit of reconciliation, The Urban Compass Software Pty Ltd acknowledges the
          Traditional Custodians of country throughout Australia and their connections to land, sea
          and community. We pay our respect to their Elders past and present and extend that respect
          to all First Nations peoples today with disability, their families, and their carers.
        </S.AcknowledgementText>
        <S.AcknowledgementImage>
          <img src={traditionalFlag} alt="traditionalFlag" />
        </S.AcknowledgementImage>
      </S.AcknowledgementSection>

      {/* Footer */}
      <S.Footer>
        <S.FooterWrapper>
          <S.FooterLeftSection>
            <S.FooterText>
              © {getCurrentYear()}{' '}
              <S.FooterLink href="https://urbancompasssoftware.com/" target="_blank">
                Urban Compass
              </S.FooterLink>
              . All rights reserved.
            </S.FooterText>
            <S.FooterPolicies>
              <Link to="/terms">Terms and Conditions</Link> |{' '}
              <Link to="/policy">Privacy Policy</Link>
            </S.FooterPolicies>
          </S.FooterLeftSection>

          <S.FooterCenterSection>
            <S.SocialLinks>
              <S.SocialIcon
                href="https://www.linkedin.com/company/urban-compass-software/?viewAsMember=true"
                target="_blank"
                aria-label="LinkedIn"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                  <rect width="4" height="12" x="2" y="9" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </S.SocialIcon>
              <S.SocialIcon
                href="https://www.youtube.com/@UrbanCompassSoftware"
                target="_blank"
                aria-label="YouTube"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" />
                  <path d="m10 15 5-3-5-3z" />
                </svg>
              </S.SocialIcon>
              <S.SocialIcon href="#" aria-label="Instagram">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
                </svg>
              </S.SocialIcon>
            </S.SocialLinks>
          </S.FooterCenterSection>
        </S.FooterWrapper>
      </S.Footer>
    </S.PageWrapper>
  );
};

export default TermsPage;
